import React from "react";

const LitecoinIcon = ({ className }) => (
  <svg
    className={className}
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1364_7242)">
      <path
        d="M15.9997 0C11.7718 0.0123329 7.7217 1.70207 4.7387 4.69815C1.7557 7.69424 0.0836943 11.7517 0.0898607 15.9796C0.0960272 20.2074 1.77986 24.26 4.77159 27.2474C7.76331 30.2347 11.8183 31.9127 16.0462 31.9127C20.2741 31.9127 24.3291 30.2347 27.3208 27.2474C30.3126 24.26 31.9964 20.2074 32.0026 15.9796C32.0087 11.7517 30.3367 7.69424 27.3537 4.69815C24.3707 1.70207 20.3206 0.0123329 16.0928 0L15.9997 0Z"
        fill="#345D9D"
      />
      <path
        d="M16.2909 16.3582L14.8814 21.0912H22.3811C22.4306 21.0887 22.4802 21.0967 22.5265 21.1145C22.5728 21.1319 22.6153 21.1581 22.6516 21.1916C22.6877 21.226 22.7168 21.267 22.7374 21.3123C22.7593 21.3578 22.7712 21.4074 22.7723 21.4578V21.5814L22.1192 23.8316C22.0913 23.9383 22.027 24.0319 21.9374 24.0963C21.8487 24.1614 21.7404 24.1943 21.6305 24.1894H10.1541L12.0771 17.644L9.92578 18.2956L10.4145 16.796L12.5658 16.1429L15.2727 6.93561C15.302 6.82954 15.3667 6.73665 15.456 6.67234C15.5443 6.60725 15.6518 6.57347 15.7614 6.57634H18.6705C18.7201 6.57507 18.7695 6.58347 18.816 6.60107C18.8628 6.6181 18.9059 6.64431 18.9425 6.67816C18.9792 6.71198 19.0085 6.7531 19.0283 6.79889C19.0492 6.84462 19.0606 6.8941 19.0618 6.94434V7.06943L16.7796 14.8294L18.9323 14.1763L18.4727 15.7385L16.2909 16.3582Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_1364_7242">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default LitecoinIcon;
